<template>
<div class="top-desc pc-padding30-mobil-padding20"
  :class="{'zh': language == 'zh_CN'}"
>
  <div class="title-box">
    <div class="top-title big-title">{{$t('Use_CopyMaster_to_open_a_new_world_of_trading')}}</div>
<!--    先隐藏,等新版的上了有了操作手册,在放出来 todo-->
<!--    <div
      @click="lookPdf"
      class="top-title right-algin"
    >查看操作手册</div>-->
  </div>
  <el-row :gutter="20">
    <el-col
      :lg="12"
      :md="24"
      :sm="24"
      :xs="24"
    >
      <div class="color-box">
        <div class="up-box">
          <div class="up-left">
            <img src="../../../assets/images/icon/Group.png" alt="">
            <span class="sub-title">{{$t('MAM_main_account')}}</span>
          </div>
          <span @click="openAccountHandle('master')" class="up-right">
            {{$t('Open_an_account')}}
            <i class="el-icon-right"></i>
          </span>
        </div>
        <p class="desc">{{$t('The_MAM_main_account_can_be_entrusted_to_manage_account_funds_and_independent_transactions_are_not_supported')}}</p>
      </div>
    </el-col>
    <el-col
      :lg="12"
      :md="24"
      :sm="24"
      :xs="24"
    >
      <div class="color-box">
        <div class="up-box">
          <div class="up-left">
            <img src="../../../assets/images/icon/Vector.png" alt="">
            <span class="sub-title">{{$t('MAM_Investor')}}</span>
          </div>
          <span @click="openAccountHandle('sub')" class="up-right">
            {{$t('Open_an_account')}}
            <i class="el-icon-right"></i>
          </span>
        </div>
        <p class="desc">{{$t('MAM_investment_accounts_can_be_entrusted_to_manage_their_account_funds_and_charge_corresponding_fees_to_support_independent_transactions')}}</p>
      </div>
    </el-col>
  </el-row>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: "topDesc",
  computed: {
    ...mapGetters(['language']),
  },
  methods: {
    openAccountHandle(strType){
      //点击对应的类型,打开对应的账号类型开户弹框
      this.$emit('open-account',strType);
    },
    lookPdf(){
      // 中文版和英文版, 点击打开对应语言的版本pdf todo
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 1400px) {
  .top-desc.zh {
    .color-box {
      height: 108px;
    }
  }
}

.top-desc {
  background-color: #ffffff;
  border-radius: 6px;
  margin-bottom: 20px;
  .title-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .top-title {
    color: #5E5873;

    &.right-algin {
      text-align: right;
      font-size: 14px;
    }
  }
  .big-title {
    font-weight: 600;
    font-size: 18px;
  }
  .color-box {

    margin-top: 20px;
    padding: 15px;
    background-color: rgba(186, 191, 199, 0.2);
    border-radius: 6px;
    .up-box {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .sub-title {
        font-size: 16px;
        font-weight: 600;
        padding-left: 15px;
      }
      .el-icon-right {
        font-size: 18px;
      }
    }
    .desc {
      font-size: 16px;
      font-weight: 400;
    }
  }
  .up-right {
    cursor: pointer;
  }
  .up-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
}
</style>
